export const GET_USER_ADDRESS_REQUEST = 'GET_USER_ADDRESS_REQUEST';
export const GET_USER_ADDRESS_REQUEST_SUCCESS = 'GET_USER_ADDRESS_REQUEST_SUCCESS';
export const GET_USER_ADDRESS_REQUEST_FAILURE = 'GET_USER_ADDRESS_REQUEST_FAILURE';

export const CREATE_USER_ADDRESS_REQUEST = 'CREATE_USER_ADDRESS_REQUEST';
export const CREATE_USER_ADDRESS_SUCCESS = 'CREATE_USER_ADDRESS_SUCCESS';
export const CREATE_USER_ADDRESS_FAILURE = 'CREATE_USER_ADDRESS_FAILURE';

export const CHANGE_USER_ADDRESS_REQUEST = 'CHANGE_USER_ADDRESS_REQUEST';
export const CHANGE_USER_ADDRESS_SUCCESS = 'CHANGE_USER_ADDRESS_SUCCESS';
export const CHANGE_USER_ADDRESS_FAILURE = 'CHANGE_USER_ADDRESS_FAILURE';

export const REMOVE_USER_ADDRESS_REQUEST = 'REMOVE_USER_ADDRESS_REQUEST';
export const REMOVE_USER_ADDRESS_SUCCESS = 'REMOVE_USER_ADDRESS_SUCCESS';
export const REMOVE_USER_ADDRESS_FAILURE = 'REMOVE_USER_ADDRESS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/constants/user_address.constants.js